import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useLocation } from 'react-router';
import { FeaturedForeignLanguageEntryPage } from './FeaturedForeignLanguageEntryPage';
import { LanguageLearningProductsPage } from './allproducts/LanguageLearningProductsPage';
import { CheckLoanFormat } from '../../../shared/components/CheckLoanFormat';
import { MULTI_LANGUAGE_SHOP, useFeature } from '../../../shared/utils/togglz';
import { ProductSelectionProvider } from '../../../shared/product-selection/ProductSelectionContext';

const LanguageLearningRouteSwitch = () => {
    const { pathname, search } = useLocation();
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);

    if (isMultiLanguageShopEnabled) {
        const redirectPath = pathname.replace('/language', `/shop/en`);

        return <Navigate to={{ pathname: redirectPath, search }} replace />;
    }

    return (
        <Routes>
            <Route index element={<Navigate to="all" replace />} />

            <Route
                path=":loanFormat"
                element={
                    <CheckLoanFormat>
                        <FeaturedForeignLanguageEntryPage />
                    </CheckLoanFormat>
                }
            />

            <Route path=":languageId">
                <Route path="products">
                    <Route index element={<Navigate to="all" replace />} />
                    <Route
                        path=":loanFormat"
                        element={
                            <CheckLoanFormat>
                                <ProductSelectionProvider>
                                    <LanguageLearningProductsPage />
                                </ProductSelectionProvider>
                            </CheckLoanFormat>
                        }
                    />
                </Route>

                {/* PORTAL-3993 redirect all pages to products */}
                <Route path="featured" element={<Navigate to="../products" replace />} />
                <Route path="newlyadded" element={<Navigate to="../products" replace />} />
            </Route>
        </Routes>
    );
};

export default LanguageLearningRouteSwitch;
